import { INITIATE_FILE_UPLOAD } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface RequestResponse {
    error: boolean;
    document_id: string;
    forms?: FormsEntity[] | null;
    message?: string;
}
export interface FormsEntity {
    url: string;
    fields: Fields;
}
export interface Fields {
    key: string;
    bucket: string;
    'X-Amz-Algorithm': string;
    'X-Amz-Credential': string;
    'X-Amz-Date': string;
    'X-Amz-Security-Token': string;
    Policy: string;
    'X-Amz-Signature': string;
}

export interface RequestBody {
    dt: string;
    sh: boolean;
    tg?: string[] | null;
    patient_oid: string;
    files: FilesEntity[];
    p_uuid?: string;
    p_poid?: string;
}
export interface FilesEntity {
    contentType: string;
}

export default (request: RequestBody): Promise<RequestResponse> => {
    return fetchWithRefresh(INITIATE_FILE_UPLOAD, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
};
